import React, { useCallback, useRef, useState } from "react";

const ICONS = {
  home: <><path d="M3 11l9-8 9 8" /><path d="M5 10v10h14V10" /></>,
  orders: <><rect x="5" y="3" width="14" height="18" rx="2" /><path d="M9 8h6M9 12h6M9 16h4" /></>,
  users: <><circle cx="9" cy="8" r="3.5" /><path d="M2.5 20c0-3.6 2.9-6 6.5-6s6.5 2.4 6.5 6" /><path d="M16 4.5a3.5 3.5 0 010 7M18 14.5c2 .7 3.5 2.6 3.5 5.5" /></>,
  wallet: <><path d="M3 7a2 2 0 012-2h13v4" /><path d="M3 7v11a2 2 0 002 2h15V9H5a2 2 0 01-2-2z" /><circle cx="16.5" cy="14.5" r="1" /></>,
  box: <><path d="M21 8l-9-5-9 5 9 5 9-5z" /><path d="M3 8v8l9 5 9-5V8M12 13v8" /></>,
  logout: <><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" /><path d="M16 17l5-5-5-5M21 12H9" /></>,
  phone: <path d="M5 4h4l2 5-2.5 1.5a11 11 0 005 5L15 13l5 2v4a2 2 0 01-2 2A16 16 0 013 6a2 2 0 012-2z" />,
  pin: <><path d="M12 21s7-6.2 7-11.5A7 7 0 005 9.5C5 14.8 12 21 12 21z" /><circle cx="12" cy="9.5" r="2.5" /></>,
  check: <path d="M5 12.5l4.5 4.5L19 7" />,
  plus: <path d="M12 5v14M5 12h14" />,
  alert: <><path d="M12 3l10 18H2L12 3z" /><path d="M12 10v5M12 18h.01" /></>,
};

export const Icon = ({ name, size = 18 }) => (
  <svg className="ic" viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor"
    strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {ICONS[name]}
  </svg>
);

const LABELS = {
  pendiente: "Pendiente", tomado: "En camino", entregado: "Entregado", pagado: "Pagado",
  vencido: "Vencido", activo: "Activo", suspendido: "Suspendido",
};
export const Badge = ({ s }) => <span className={`bd bd-${s}`}>{LABELS[s] || s}</span>;

export const Stat = ({ label, value, tone }) => (
  <div className={`stat ${tone ? `stat-${tone}` : ""}`}>
    <span>{label}</span>
    <b>{value}</b>
  </div>
);

export const Empty = ({ children }) => <div className="empty">{children}</div>;

export function useToast() {
  const [toast, setToast] = useState(null);
  const timer = useRef();
  const notify = useCallback((text, isError = false) => {
    setToast({ text, isError });
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setToast(null), 4500);
  }, []);
  const node = toast ? (
    <div className={`toast ${toast.isError ? "toast-err" : ""}`} role="status">{toast.text}</div>
  ) : null;
  return [node, notify];
}